























































































export default {
	name: 'dashboardproductos',
	props: {
		historial: {
			type: Boolean,
		},
		method: {
			type: Function,
		},
	},
	computed: {
		visitados() {
			return this.$store.state.productos.visitados;
		},
		comprados() {
			return this.$store.state.productos.comprados;
		},
		promociones() {
			return this.$store.state.productos.promociones;
		},
		loadingpromo() {
			return this.$store.state.productos.loadingpromo;
		},
		loadingvisita() {
			return this.$store.state.productos.loadingvisita;
		},
		loadingcompra() {
			return this.$store.state.productos.loadingcompra;
		},
	},
	methods: {
		redirect(id) {
			this.$store.dispatch('loadProducto', id);
			this.method(false);
			this.$router.push('/1/pedidos/' + id);
		},
	},
	mounted() {
		this.$store.dispatch('loadVisitados');
		this.$store.dispatch('loadComprados');
		this.$store.dispatch('loadPromociones');
	},
};
